import { ParserContentData, CODE_BLOCK_REGEX } from '@libs';

// получение текста в блоке важно
export const getImportantText = (data, keys = {}) => {
  const { groupKey = '', importantKey = '' } = keys;
  const itemData = ParserContentData.getItemData(data, {
    groupKey,
    blockKey: importantKey,
    itemKey: 'important_information',
  });

  return itemData.formData.text || '';
};

// получение контента и списка секций
export const getContentsAndSections = (data, keys = {}) => {
  const { groupKey = '', contentKey = '' } = keys;
  const items = ParserContentData.getItemsArray(data, { groupKey, blockKey: contentKey });
  const sections = [];

  const contents = items.map((item, index) => {
    const { formData } = ParserContentData.getDataFromItem(item);
    const { title, text } = formData;
    const id = index + 1; // чтобы хэк совпадал с порядковым номером секции

    sections.push({ id, title });

    return { id, title, text };
  });

  return { sections, contents };
};

export const normalizeTextPage = (data = {}, keys = {}) => {
  const { groupKey, contentKey, importantKey } = keys;
  const important = getImportantText(data, { groupKey, importantKey });
  const { contents, sections } = getContentsAndSections(data, { groupKey, contentKey });

  return { contents, sections, important };
};

export const normalizeAndClearText = (text = '') => {
  if (!text) {
    return '';
  }

  let normalContent = text;

  // Маркеры [codeblock ...] выносим в плейсхолдеры, чтобы правила ниже
  // не удалили переносы строк и не схлопнули отступы внутри кода
  const codeBlocks = [];

  normalContent = normalContent.replace(CODE_BLOCK_REGEX, (match) => {
    codeBlocks.push(match);
    return `[[codeblock:${codeBlocks.length - 1}]]`;
  });

  const replaceYouTube = (value) => {
    const link = value.slice(9, -10);

    return `<figure class="video"><iframe src="${link}" width="560" height="315" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></figure>`;
  };
  const replaceImage = (value) => {
    return `<span style="display:block;">${value}</span>`;
  };
  const rgs = [
    [/\n/g, ''],
    [/dir="[A-Za-z]+"/g, ''],
    [/margin-(top|bottom|left|right):\s?0(pt|px)?;/g, ''],
    [/margin-(left|right):\s?-[\d.]+(px|pt);/g, ''],
    [/font-family:\s?(.*?);/g, ''],
    // [/color:\s?#0{3,6};/g, ''],
    // [/color:\s?rgb\(0\s?,\s?0,\s?0\);/g, ''],
    [/background(-color|):\s?(.*?);/g, ''],
    [/font-weight:\s?400;/g, ''],
    // [/font-size:\s?(.*?);/g, ''],
    // [/line-height:\s?(.*?);/g, ''],
    [/font-style:\s?normal;/g, ''],
    [/font-variant:\s?normal;/g, ''],
    [/text-decoration:\s?none;/g, ''],
    [/vertical-align:\s?baseline;/g, ''],
    [/white-space:\s?pre;/g, ''],
    [/white-space:\s?pre-wrap;/g, ''],
    [/overflow:\s?hidden;/g, ''],
    [/(width|height)(=|:\s?)"?([0-9]+px;|[0-9]+")/g, ''],
    [/\s?style=""/g, ''],
    [/\s{2,}/g, ' '],
    [/;{2,}/g, ';'],
    [/\[YouTube\]*.*\[\/YouTube\]/g, replaceYouTube],
    [/<img [^>]*src="[^"]*"[^>]*>/g, replaceImage],
  ];

  rgs.forEach(([rg, value]) => {
    normalContent = normalContent.replace(rg, value);
  });

  return normalContent.replace(/\[\[codeblock:(\d+)\]\]/g, (_match, index) => codeBlocks[index]);
};
